/* eslint-disable */
//esimerkkifunktio
import { testi } from './customfunctions';

testi();

export default {
  
}

//expandable content
$('.expandActivator').click(function(){
  var id = $(this).attr('id');

  var child = $(this).find('.expandButton');

  child.find('.expandMinus').toggle();
  child.find('.expandPlus').toggle();

  $( '#expand_content_' + id ).slideToggle( "fast", function() {
    // Animation complete.
  });
});

//Popups
if($(".popup-div-container").length) { //check if main container exists
 
  //Show popup
  $(".popup-open").click(function(e) {
      e.stopPropagation();
      $(this).siblings(".popup-main-container").addClass('active');
  });

  $(".popup-main-container").click(function(e) {
      e.stopPropagation();
  });

  //Hide popup
  $(document).on('click', function (e) {
      $(".popup-main-container").removeClass('active');
  });

  $(".popup-main-container").find(".popup-exit").click(function() { 
      $(".popup-main-container").removeClass('active');
  });
}

/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/autoload/modules.js